module.exports = __webpack_public_path__ + "static/media/lily-collins-lose.8e30e227.jpg";